// extracted by mini-css-extract-plugin
export default {"button":"InvoicePaymentInfo_button__TMGne"};